var _rect, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBrowseJobicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    rx: 20,
    fill: "#FDE2E1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.25 30.375V28.125C29.25 26.3348 29.9612 24.6179 31.227 23.352C32.4929 22.0862 34.2098 21.375 36 21.375C37.7902 21.375 39.5071 22.0862 40.773 23.352C42.0388 24.6179 42.75 26.3348 42.75 28.125V30.375M23.625 30.375C23.3266 30.375 23.0405 30.4935 22.8295 30.7045C22.6185 30.9155 22.5 31.2016 22.5 31.5V46.6875C22.5 48.8137 24.3113 50.625 26.4375 50.625H45.5625C47.6887 50.625 49.5 48.9016 49.5 46.7754V31.5C49.5 31.2016 49.3815 30.9155 49.1705 30.7045C48.9595 30.4935 48.6734 30.375 48.375 30.375H23.625Z",
    stroke: "url(#paint0_linear_1241_18755)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1241_18755",
    x1: 22.5,
    y1: 36,
    x2: 49.5,
    y2: 36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A1D1C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrowseJobicon);
export default __webpack_public_path__ + "static/media/Browse Job icon.274bc230741eebed1a8c7219058314a4.svg";
export { ForwardRef as ReactComponent };